import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";

import { operatorsSkillQueryOptions } from "../../lib/operatorsSkillsReactQuery";
import { OPERATORS_SKILLS_PATH } from "../../operatorsRoutes";
import { OperatorsSubpageShell } from "../operators/OperatorsSubpageShell";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { SkillEditor } from "./SkillEditor";

export function SkillDetailPage({ skillId }: { skillId: string }) {
  const navigate = useNavigate();
  const skillQuery = useQuery(operatorsSkillQueryOptions(skillId));

  return (
    <OperatorsSubpageShell
      header={
        <Button
          size="xs"
          variant="ghost"
          onClick={() => void navigate({ to: OPERATORS_SKILLS_PATH })}
        >
          <ArrowLeftIcon /> Skills
        </Button>
      }
      contentClassName="max-w-5xl"
    >
      {skillQuery.isPending ? (
        <p role="status" className="py-12 text-center text-sm text-muted-foreground">
          Loading skill…
        </p>
      ) : skillQuery.isError ? (
        <Card role="alert" className="p-6 text-sm text-destructive">
          {skillQuery.error instanceof Error ? skillQuery.error.message : "Could not load skill."}
        </Card>
      ) : (
        <SkillEditor key={skillQuery.data.id} skill={skillQuery.data} />
      )}
    </OperatorsSubpageShell>
  );
}
